import React, { useState } from 'react';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import { Form, Row, Col } from 'react-bootstrap';
import { FaBug } from "react-icons/fa";
import { VscDebug } from "react-icons/vsc";
import { TbPlantOff, TbCategory } from "react-icons/tb";
import { GrShare } from "react-icons/gr";
import { RiVirusLine } from "react-icons/ri";
import { ObservationCategory } from '../../Constants/SharedMapFeature';

export const getObservationFilters = (localRetrieve, t) => {
    let filters = localRetrieve().filter(f => f.categoryId);
    if (filters.length === 0) {
        filters = createObservationTypes(t, []);
    }
    else {
        // Get filters with updated labels based on current language, 
        // but keep the value from local storage
        filters = createObservationTypes(t, filters);
    }
    return filters;
}

export const createObservationTypes = (t, savedValues) => {
    return [
        {
            categoryId: ObservationCategory.Pests,
            label: t('Pests'),
            value: savedValues.find(f => f.categoryId === ObservationCategory.Pests)?.value ?? true,
        },
        {
            categoryId: ObservationCategory.Diseases,
            label: t('Diseases'),
            value: savedValues.find(f => f.categoryId === ObservationCategory.Diseases)?.value ?? true,
        },
        {
            categoryId: ObservationCategory.Weeds,
            label: t('Plants'),
            value: savedValues.find(f => f.categoryId === ObservationCategory.Weeds)?.value ?? true,
        },
        {
            categoryId: ObservationCategory.Other,
            label: t('Other'),
            value: savedValues.find(f => f.categoryId === ObservationCategory.Other)?.value ?? true,
        }
    ];
};

export const handleObservationFilterChange = (observationFilters, setObservationFilters, index, value) => {
    const updatedFilters = observationFilters.map((filter, i) => {
        if (i === index) {
            return { ...filter, value: value };
        }
        return filter;
    });
    setObservationFilters(updatedFilters);
};

export const SharingObsPopover = (addNew, openObservationList, t, observationFilters, setFilters, onFilterChange) => {
    const getRowIcon = (index, size, color) => {
        if (index === 0) return <FaBug className="filter-icon button-icon" fontSize={size} color={color} />;
        if (index === 1) return <RiVirusLine className="filter-icon button-icon" fontSize={size} color={color} />;
        if (index === 2) return <TbPlantOff className="filter-icon button-icon" fontSize={size} color={color} />;
        if (index === 3) return <TbCategory className="filter-icon button-icon" fontSize={size} color={color} />;
    }

    return (
        <Popover className="sharing-popover">
            <Popover.Body className="sharing-pop-body">
                <Row xs={"auto"}>
                    <Col xs={12}>
                        <Button variant="new-outline-success" onClick={() => { addNew(); }} className="filter-button">+ {t('AddMark')}</Button>
                    </Col>
                </Row>
                <Row xs={"auto"}>
                    <Col xs={12}>
                        <Button variant={observationFilters.every(o => o.value) ? "new-success" : "new-outline-success"} className="filter-button" onClick={() => {
                            var newFilters = [];
                            observationFilters.forEach((filter, i) => {
                                newFilters.push({ ...filter, value: true });
                            });
                            setFilters(newFilters);
                        }}>{t('ShowAll')}
                        </Button>
                    </Col>
                </Row>
                {observationFilters.map((filter, index) => (
                    <Row xs="auto" key={index} className="sharing-filter-row">
                        <Col className="sharing-filter-col">
                            <Form.Check
                                className={"sharing-filter-checkbox"}
                                type='checkbox'
                                id={`observation-filter-${index}`}
                                checked={filter.value}
                                onChange={(e) => onFilterChange(index, e.target.checked)}
                            />
                        </Col>
                        <Col xs={8} onClick={() => onFilterChange(index, !filter.value)}>
                            <Form.Label className="filter-label">{getRowIcon(index, 16, '#198754')} {filter.label}</Form.Label>
                        </Col>
                    </Row>
                ))}
                <Row>
                    <Button className="filter-bottom-btn" onClick={() => { openObservationList() }}> {t('OwnShared')}
                        <GrShare className="btn-icon" fontSize={16} />
                    </Button>
                </Row>
            </Popover.Body>
        </Popover>
    );
};

